const defaultState = {
  error: null,
  fetching: false,
  fetched: false,
  saved: false
};

const searchReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SEARCH_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true,
      };
    }
    case 'SEARCH_CONTRACTRATE_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true,
      };
    }
    case 'SEARCH_CONTRACTRATE_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        contractRateResult: {
          [action.payload.data.tableName.replace('-', '')]: {
            data: action.payload.data.items,
            totalRows: action.payload.data.totalRows,
            lastEvaluatedKey: action.payload.data.lastEvaluatedKey,
          }
        },
      };
    }

    case 'SEARCH_LIST_FETCH_FULFILLED': {
      const tableKey = 'locationsList';
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        [tableKey]: {
          data: action.payload.data.items,
          totalRows: action.payload.data.totalRows,
          lastEvaluatedKey: action.payload.data.lastEvaluatedKey,
        },
      };
    }

    case 'SEARCH_FETCH_FULFILLED': {
      const tableKey = action.payload.data.tableName.replace('-', '');

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        [tableKey]: {
          data: action.payload.data.items,
          totalRows: action.payload.data.totalRows,
          lastEvaluatedKey: action.payload.data.lastEvaluatedKey,
        },
      };
    }

    case 'SEARCH_LIST_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.playload,
      };
    }

    case 'SEARCH_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.playload,
      };
    }
    case 'SEARCH_CONTRACTRATE_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.playload,
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default searchReducer;


// WEBPACK FOOTER //
// ./src/reducers/search.js